/* Ott-common */
import { EntityName } from '@dtvgo/backend-service/normalize';

export default function useLockIcon(content) {
  if (!content) {
    return {};
  }
  if (content?.schema === EntityName.CHANNEL) {
    return !content?.isEntitled;
  }
  return content?.shouldDisplayLockIcon || false;
}
